import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';

import VendorsNonGrid from './components/VendorsNonGrid';
import AddVendorDialog from './components/AddVendorDialog';
import * as vendorsActions from 'actions/vendorsActions';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

export default connect(
  store => ({
    showPage: store.authentication.showPage,
    addVendorDialogIsOpen: store.vendors.addVendorDialogIsOpen,
    vendorDetails: store.vendors.vendorDetails,
    editVendor: store.vendors.editVendor,
  }),
  { ...vendorsActions, submit }
)(
  class VendorList extends Component {
    submitForm = formData => {
      const vendorId = this.props.vendorDetails.id;
      if (this.props.editVendor) {
        this.props.putVendor(formData, vendorId);
      } else {
        this.props.addVendor(formData);
      }
      this.props.closeAddVendorDialog();
    };

    render() {
      return (
        <div className="body" role="main">
          <div className="centers">
            <div className="stage-header clearfix" style={{ marginBottom: '25px' }}>
              <span className="page-title">
                {getTranslatedString('landlordPortal.vendors.vendors')}
              </span>
              <RenderIfToggleOn toggle="ui.vendors.add_vendor">
                <FlatButton
                  label={getTranslatedString('landlordPortal.vendors.addVendor')}
                  type="submit"
                  primary={true}
                  backgroundColor={AccentColor()}
                  hoverColor="grey"
                  onClick={this.props.openAddVendorDialog}
                  style={{
                    color: 'white',
                    float: 'right',
                    height: '30px',
                    fontSize: '13px',
                    lineHeight: '30px',
                    marginTop: '3px',
                  }}
                />
              </RenderIfToggleOn>
            </div>

            <AddVendorDialog
              addVendorDialogIsOpen={this.props.addVendorDialogIsOpen}
              closeAddVendorDialog={this.props.closeAddVendorDialog}
              editVendor={this.props.editVendor}
              submitForm={this.submitForm}
              vendorDetails={this.props.vendorDetails}
              submit={this.props.submit}
              submitting={this.props.submitting}
            />

            <div className="dashboard-container" ref="MaintenanceContainer">
              <VendorsNonGrid />
            </div>

            <div style={{ height: '100px' }} />
          </div>
        </div>
      );
    }
  }
);
